import css from 'styled-jsx/css'

import { colors } from '../../../theme'
import common from '../../../theme/common'
import sizes from '../../../theme/sizes'


export default css`
  .route {
    display: flex;
  }

  .route :global(a) {
    display: flex;
    flex-direction: row;
    align-items: center;
    text-decoration: none;
    color: ${colors.pureWhite};
    transition: opacity 150ms ease;
  }

  .route :global(.label) {
    ${common.navbarLink};

    color: ${colors.pureWhite};
    opacity: 0.3;
    font-family: 'Nexa Bold', serif;
    margin-right: 3rem;
    transition: opacity 150ms ease;
    white-space: nowrap;
    text-transform: uppercase;
  }

  .route.selected :global(.cloud) {
    opacity: 1;
    transform: scale(1) rotate(0deg);
  }

  .route.selected :global(.label) {
    opacity: 1;
  }

  .route :global(a .link):active .label {
    opacity: 0.6;
  }
    
  @media screen and (min-width: ${sizes.media.tablet.endMaxWidth}) {
    .route :global(a .link):hover .label {
      opacity: 0.8;
    }
  
    .route:not(.selected) :global(.link:hover .label) {
      opacity: 1;
    }
  }


  @media screen and (max-width: ${sizes.media.mobile.maxWidth}) {

    .route :global(.label) {
      font-size: 1.4rem;
    }


    // .route :global(.label) {
    //   ${common.headerSmall};
    // }

    .route :global(.cloud) {
      width: 4rem;
      height: 4rem;
    }
  }
`
